import { Vue, Options } from 'vue-class-component';
import {
  PlantDetailDTO,
  PlantDTO,
  PlantRoomCount,
  RoomDTO,
  RoomType,
} from '@/../client-generator/generated-clients/plants';
import { getRoomIconFromType } from '@/core/utils/utils';
import configurationsClient from '@/core/services/configurations-service';
import { DefaultRoomDTO } from '@/../client-generator/generated-clients/configurations';

import NumberButtons from '@/views/components/NumberButtons/NumberButtons.vue';

@Options({
  name: 'DialogPlantCreateStep3',
  props: {
    plant: {
      required: true,
      type: Object as () => PlantDTO,
    },
    isInEditMode: {
      type: Boolean,
    },
  },
  components: {
    NumberButtons,
  },
  emits: ['is-loading'],
})
export default class DialogPlantCreateStep3 extends Vue {
  plant!: PlantDTO;
  roomTypes: DefaultRoomDTO[] = [];
  getRoomIcon = getRoomIconFromType;
  isInEditMode!: boolean;

  get stepTitle() {
    if (this.isInEditMode) return this.$t('AppResource.AddARoom');
    return this.$t('AppResource.CreateStructure');
  }
  get stepSubTitle() {
    if (this.isInEditMode) return this.$t('AppResource.ChooseRoomToAdd');
    return this.$t('AppResource.SelectRoomsText');
  }

  get theRooms() {
    return this.isInEditMode
      ? (this.plant as PlantDetailDTO).rooms
      : (this.plant as PlantDTO).roomsCounts;
  }

  async created() {
    this.fetchRooms();
  }

  async fetchRooms() {
    this.$emit('is-loading', true);
    try {
      this.roomTypes = await configurationsClient.defaultRoomsList();
      this.roomTypes.forEach(r => r.label = this.$t(`AppResource.${RoomType[r.type!]}`))
      if (this.isInEditMode) this.roomTypes.forEach((rt) => (rt.count = 0));
      const theRooms = this.plant.roomsCounts;
      if (!theRooms || (theRooms && theRooms.length === 0)) {
        (this.plant as PlantDTO).roomsCounts = this.roomTypes.map(
          (rt) =>
            ({
              type: rt.type!,
              count: rt.count!,
            } as PlantRoomCount)
        );
      }

      this.roomTypes = this.roomTypes.map(
        (rt) =>
          ({
            ...rt,
            count: (() => {
              if (!this.isInEditMode) {
                const plantRoomCount = theRooms?.find(
                  (rc) => rc.type === rt.type
                );
                if (plantRoomCount) {
                  return plantRoomCount.count;
                }
                return rt.count;
              }
              return 0;
            })(),
          } as DefaultRoomDTO)
      );
    } catch (error) {
      console.log(error);
    } finally {
      this.$emit('is-loading', false);
    }
  }

  updatePlantRoom(room: DefaultRoomDTO) {
    const plantRoom = this.plant.roomsCounts?.find(
      (rc) => rc.type === room.type
    );

    if (!plantRoom) {
      console.log('Plant room not found');
      return;
    }

    plantRoom.count = room.count;
    plantRoom.label = room.label;
  }
}
